'use strict';

import $ from 'jquery';

export default class HomeBanner {
  constructor() {
  }
}
